import { useEffect, useState } from 'react';

/** 手机端断点（与 Tailwind md 边界一致：<768px 视为手机布局） */
export const MOBILE_QUERY = '(max-width: 767px)';

/**
 * 是否手机窄屏布局。
 *
 * 10-18 手感修复：此前全站只有「桌面壳 + Electron 判定」，没有任何窄屏分支——
 * 安卓端（WebView 壳加载同一站点）在 390px 下侧栏占 280px、内容区被挤到约 110px，
 * 实测 /ingest/notes 有 823 个高度 <32px 的可点元素、工作台存在 430px 宽面板被裁切。
 */
export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia?.(MOBILE_QUERY).matches === true
  );

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    const onChange = () => setIsMobile(mq.matches);
    onChange(); // 首帧后再校准一次（水合/旋转屏幕）
    mq.addEventListener?.('change', onChange);
    return () => mq.removeEventListener?.('change', onChange);
  }, []);

  return isMobile;
};

export default useIsMobile;
